import { Box, Flex, Heading, Spinner, Stack, VStack } from "@chakra-ui/react";
import React, { useContext, useEffect, useState } from "react";
import { formatDateWithAmPm } from "../../../utils/DateFormat/dateFormatWithTimeAmPm";
import { fetchController } from "../../../utils/FetchController/fetchController";
import { getHostDomain } from "../../../utils/utils";
import { AgencyContext } from "../AgencyProvider/AgencyProvider";
import ProgressBar from "./ProgressBar";

const Usage = () => {
  const baseUrl = getHostDomain();
  const [loading, setLoading] = useState(true);
  const endpoint = "/api/v1/analytics/user_credits";
  const urlHit = baseUrl + endpoint;
  const [usageData, setUsageData] = useState();
  const [userDetails, setUserDetails] = useState();
  const fetchAnalyticsData = async () => {
    setLoading(true);
    try {
      const getData = await fetchController(urlHit, "GET");
      setUsageData(getData);
    } catch (error) {
      console.error("Error fetching analytics data:", error);
    }
  };
  const getUserDetails = async () => {
    try {
      const userDetailsRes = await fetchController(
        baseUrl + `/api/v1/user`,
        "GET"
      );

      setUserDetails(userDetailsRes.data);
    } catch (error) {
      console.error("Error fetching user details", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAnalyticsData();
    getUserDetails();
  }, []);
  const agency = useContext(AgencyContext);
  const { textColor, cardBg } = agency;

  return (
      <Flex direction={"column"} gap={3} w={"100%"} h={"100%"}>
        <Flex gap={2} w={"100%"} alignItems="center" p={2}>
          <Heading color={textColor} fontSize="xl">
            Your Usage
          </Heading>
        </Flex>

        <Box
          mt={3}
          display="flex"
          flexDirection="column"
          alignItems="start"
          justifyContent="start"
          background={cardBg}
          padding={10}
          width="100%"
          boxShadow="md"
          borderRadius="8px"
          minH={"300px"}
        >
          {loading ? (
            <Flex
              justifyContent={"center"}
              alignItems={"center"}
              h={"100%"}
              w={"100%"}
            >
              <Spinner size={"lg"} />
            </Flex>
          ) : (
            <Stack width="100%" spacing={4} direction="column">
              {usageData && (
                <>
                  <ProgressBar
                    allocated={usageData.allocated}
                    utilized={usageData.utilized}
                  />
                  <Box mt={4} fontWeight="500" display="flex">
                    Credits will be refreshed on{" "}
                    {formatDateWithAmPm(userDetails?.next_credits_refresh)}
                  </Box>
                </>
              )}
            </Stack>
          )}
        </Box>
      </Flex>
  );
};

export default Usage;
